import { motion } from "framer-motion";

export const PageHero = ({ overline, title, subtitle, image }) => (
  <section className="relative h-[52vh] min-h-[420px] flex items-end overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0">
      <motion.img
        src={image}
        alt={title}
        className="w-full h-full object-cover"
        initial={{ scale: 1.12 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/90 via-black/20 to-transparent" />
    </div>
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 pb-14 md:pb-20 w-full">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4"
      >
        {overline}
      </motion.p>
      <span className="block overflow-hidden">
        <motion.h1
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ delay: 0.15, duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif-display text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight text-white"
        >
          {title}
        </motion.h1>
      </span>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.55, duration: 0.8 }}
          className="mt-4 text-base md:text-lg text-white/70 max-w-2xl"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
